import { createSlice } from '@reduxjs/toolkit'
import { sortByProp } from '../../../../../../helpers/common'
import { register } from '../../../../../../helpers/reducerRegistry'
import { SORT_DIRECTION } from '../../../../../../utils/common'
import { handleData, handleYearHeader } from '../../helpers'
import { getFdiData } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/macroeconomics/fdi',
  initialState: {
    isLoading: true,
    year: undefined,
    years: [],
    ids: [],
    data: {},
    headers: [],
    rawData: [],
    isShowData: true,
    sortTable: {
      sortBy: '',
      sortDirection: '',
    },
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.year = undefined
      state.years = []
      state.ids = []
      state.data = {}
      state.headers = []
      state.rawData = []
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
    },
    changeYear: (state, action) => {
      state.year = action.payload
    },
    changeIsShowData: (state, action) => {
      state.isShowData = action.payload
    },
    sort: (state, action) => {
      state.sortTable = action.payload
      if (action.payload.sortDirection) {
        state.ids = sortByProp(
          Object.values(state.data),
          action.payload.sortBy,
          action.payload.sortDirection === SORT_DIRECTION.DESC,
          false,
        ).map((item) => item.id)
      } else {
        state.ids = [...new Set(state.rawData.map((item) => item.vsicId))]
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getFdiData.pending, (state) => {
      state.isLoading = true
      state.year = undefined
      state.years = []
      state.ids = []
      state.data = {}
      state.headers = []
      state.rawData = []
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
    })
    builder.addCase(getFdiData.fulfilled, (state, { payload = [] }) => {
      state.isLoading = false
      state.ids = [...new Set(payload.map((item) => item.vsicId))]
      state.years = [...new Set(payload.map((item) => item.year))]
      state.headers = handleYearHeader(state.years)
      state.data = handleData(payload, state.ids, state.years)
      state.rawData = payload
      state.year = state.years.length ? state.years[0] : undefined
    })

    builder.addCase(getFdiData.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectYears = (state) => state[slice.name].years
export const selectItem = (rowId, colId) => (state) =>
  state[slice.name].data[rowId][colId]
export const selectData = (state) => state[slice.name].data
export const selectHeaders = (state) => state[slice.name].headers
export const selectYear = (state) => state[slice.name].year
export const selectIds = (state) => state[slice.name].ids
export const selectRawData = (state) => state[slice.name].rawData
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectIsShowData = (state) => state[slice.name].isShowData
export const selectSortTable = (state) => state[slice.name].sortTable

export const { changeYear, resetStore, changeIsShowData, sort } = slice.actions

register(slice.name, slice.reducer)
